import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer container mx-auto px-4 mb-4" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"flex justify-end\"><a class=\"flex-initial w-8 h-8 rounded-full pr-4 social\" href=\"http://instagram.com/nitomeapp\" target=\"_external\"><img src=\"/icons/tabler-icon-brand-instagram.svg\"></a><a class=\"flex-initial w-8 h-8 rounded-full pr-4 social\" href=\"https://www.facebook.com/nitomeapp\" target=\"_external\"><img src=\"/icons/tabler-icon-brand-facebook.svg\"></a><a class=\"flex-initial w-8 h-8 rounded-full pr-4 social\" href=\"https://www.youtube.com/channel/UC1TwG1JNmDrUbjc-OZHGQbw\" target=\"_external\"><img src=\"/icons/tabler-icon-brand-youtube.svg\"></a><a class=\"flex-initial w-8 h-8 rounded-full social\" href=\"https://www.tiktok.com/@nitomeapp\" target=\"_external\"><img src=\"/icons/tabler-icon-brand-tiktok.svg\"></a><a class=\"flex-initial w-8 h-8 rounded-full social\" href=\"https://discord.gg/WEdgFvGM\" target=\"_external\"><img src=\"/icons/tabler-icon-discord.svg\"></a></div>", 1)
const _hoisted_4 = { class: "copyright pull-right" }
const _hoisted_5 = { class: "text-sm" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" | ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("a", _hoisted_5, "© " + _toDisplayString(_ctx.currentYear) + " nitome", 1),
        _hoisted_6,
        _createElementVNode("a", {
          class: "text-sm cursor-pointer",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToTerms && _ctx.goToTerms(...args)))
        }, _toDisplayString(_ctx.label_terms), 1),
        _hoisted_7,
        _createElementVNode("a", {
          class: "text-sm cursor-pointer",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goToPrivacy && _ctx.goToPrivacy(...args)))
        }, _toDisplayString(_ctx.label_privacy), 1)
      ])
    ])
  ]))
}